module.exports = __webpack_public_path__ + "static/media/notification-inventory-icon.672b8a1e.svg";